<template>
  <div class="kpi-rank-brand-page">
    <div id="water-mark"></div>
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" color="#3283fa" :sticky="true" :swipe-threshold="3" @change="setType">
      <van-tab class="list" v-for="(type, key) in types" :key="type" :title="type">
        <div class="legion" v-if="generalList.length">
          <div>
            <span :class="(generalIndex==-1)&&'active'" @click="switchGeneral(0,-1)">全部</span>
            <span v-for="(item,index) of generalList" :key="item.id" :class="(index==generalIndex)&&'active'" @click="switchGeneral(item.id,index)">{{item.name}}</span>
          </div>
        </div>
        <div class="legion" v-if="legionList.length">
          <div>
            <!-- 添加全部的参数,注意传入的全部军团的id -->
            <span :class="(legionIndex==-1)&&'active'" @click="switchLegion(0,-1)" v-if="!generalList.length">全部</span>
            <span v-for="(item,index) of legionList" :key="item.id" :class="(index==legionIndex)&&'active'" @click="switchLegion(item.id,index)">{{item.name}}({{item.brandCount||0}})</span>
          </div>
        </div>
        <van-list v-if="typeIndex === key" v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —" @load="getContents">
          <div v-if="typeIndex === 2 && list.length > 0">
            <van-cell-group class="cell-group" >
              <van-field label="请选择开始日期" v-model="startTime" readonly @click="(flag = 1) && (show = !show)" :placeholder="startTime" input-align="right"/>
              <van-field label="请选择结束日期" v-model="endTime" readonly @click="(flag = 2) && (show = !show)" :placeholder="endTime" input-align="right"/>
            </van-cell-group>
          </div>

          <!-- 排行列表 -->
          <div class="kpi-rank-brand-list">
            <div class="bottom-line" v-if="totalCount">
              <div>总数</div>
              <div>
                <span>{{Number(totalCount)}}</span> {{unit}}
              </div>
            </div>
            <div v-for="(item, key) in list" :key="key">
              <van-cell-group class="group">
                <van-cell :value="(item.score||0) + unit" is-link title-class="title" value-class="value" :to="{ name: 'kpi.rank.detail', query: { id: item.brandId,title: titledoc, type: rankType,start_time: params.start_at,end_time: params.end_at }}">
                  <template slot="title">
                    <span v-if="key === 0"><i class="icon icon-no1"></i></span>
                    <span v-if="key === 1"><i class="icon icon-no2"></i></span>
                    <span v-if="key === 2"><i class="icon icon-no3"></i></span>
                    <span v-if="key !== 0 && key !== 1 && key !== 2" class="no-num">{{item.rank}}</span>
                    <div class="img_box f fc fvc"><img :src="item.brandLogo ? item.brandLogo : 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"/></div>
                    <span class="word">
                      <div class="name one-nowrap">{{item.name}}</div>
                      <div class="progress"><span :style="'width: calc(' + (item.percent||0)*100 + '%)'"></span></div>
                    </span>
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
          </div>

        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>
  </div>
</template>

<script>
import backHome from '../../components/back-home.vue';
import { formatNumber } from '../../utils/tools';

export default {
  components: {
    backHome
  },
  data() {
    return {
      load: true,//默认一开始不执行@load的方法
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      brand_id: localStorage.getItem('brand_id') || null,
      titledoc: this.$route.query.title,
      unit: this.$route.query.unit,
      typeIndex: 0,
      types: ['总排行','昨日排行','每日排行'],
      params: {
        index: 1,
        size: 50,
        start_at: null,
        end_at: null,
        loading: false,
        finished: false,
      },
      list: [],
      legionIndex: -1,
      generalIndex: -1,
      legionList: [],//军团列表
      generalList: [],// 战区列表
      rankType: this.$route.query.type,//排行类型
      startTime: new Date(),
      endTime: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      yesterday: new Date(new Date() - 24 * 60 * 60 * 1000),
      today: new Date(),
      totalCount: 0,
      show: false,
      flag: null,
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = '品牌' + this.titledoc + '排行';
    this.maxDate.setFullYear(this.minDate.getFullYear() + 1);// 设置多大年份是后一年
    this.minDate.setFullYear(this.minDate.getFullYear() - 1);// 设置多大年份是前一年
    this.startTime = this.startTime.getFullYear() + '-' + formatNumber(this.startTime.getMonth() + 1) + '-' + formatNumber(this.startTime.getDate());
    this.endTime = this.startTime;
    this.yesterday = new Date(new Date() - 24 * 60 * 60 * 1000);
    this.yesterday = this.yesterday.getFullYear() + '-' + formatNumber(this.yesterday.getMonth() + 1) + '-' + formatNumber(this.yesterday.getDate())
    
    this.today = new Date();
    this.today = this.today.getFullYear() + '-' + formatNumber(this.today.getMonth() + 1) + '-' + formatNumber(this.today.getDate())
    
    this.getLegionList();
    this.getGeneralList()
    this.getRankList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取军团
    getLegionList(){
      this.$kpi.rank.getLegionList({
        "actId": Number(this.activity_id),
        "generalId": this.selectGeneralId,
        "page": -1,
        "size": -1
      }).then((res) => {
        console.log(res)
        if(res.code==0){
          this.legionList = res.data.list;
          this.selectLegionId = 0;
        }else if(res.code==10200){
          this.params.finished = true;
        }
      });
    },
    // 获取战区
    getGeneralList(){
      this.$kpi.rank.getGeneralList({
        "actId": Number(this.activity_id),
        "page": -1,
        "size": -1
      }).then((res) => {
        console.log(res)
        if(res.code==0){
          this.generalList = res.data.list;
        }else if(res.code==10200){
          this.params.finished = true;
        }
      });
    },
    getRankList(){
      this.params.loading = true;
      this.$kpi.rank.getBrandRankList({
        "actId": Number(this.activity_id),
        "brandId": this.brand_id,
        "catId": this.selectLegionId,
        "startTime": this.params.start_at,
        "endTime": this.params.end_at,
        "page": this.params.index || 1,
        "size": -1,
        // "size": this.params.size || 50,
        "type": this.rankType,
        "generalId": this.selectGeneralId
      }).then((res) => {
        console.log(res)
        this.params.loading = false;
        this.load = false;
        if(res.code==0){
          var data=res.data;
          this.totalCount = data.list.length&&data.list[0].totalScore||0;
          this.list = this.list.concat(data.list);
          let oTemp = null;
          let site = {logo:'https://j.weizan.cn/youxiang/icon.png',name:'优想互动'}||null;
          oTemp = this.$wm.set(80.2, this.list, site);
          document.getElementById('water-mark').appendChild(oTemp);
          if(!data.list.length||data.list.length<this.params.size){
            this.params.finished = true;
          }
        }else if(res.code==10200){
          this.params.finished = true;
        }
      });
    },
    setType(index) {
      this.params.loading = false;
      this.params.finished = false;
      this.list = [];
      this.params.index = 1;
      if (this.typeIndex === 0) {
        this.params.start_at = null;
        this.params.end_at = null;
      } else if (this.typeIndex === 1) {
        this.params.start_at = this.yesterday + ' 00:00:00';
        this.params.end_at = this.yesterday + ' 23:59:59';
      } else if (this.typeIndex === 2) {
        this.params.start_at = this.today + ' 00:00:00';
        this.params.end_at = this.today + ' 00:00:00';
      }
      var waterMark = document.getElementById('water-mark');
      var childs = waterMark.childNodes;
      var arr = [];
      for (var i = childs.length - 1; i >= 0; i--) {
        arr[i] = childs[i].innerHTML;
        waterMark.removeChild(childs[i]);
      }
      this.getRankList();
    },
    // 上拉获取排行列表
    getContents() {
      console.log(this.params.finished,this.load)
      if(this.params.finished||this.load) return;
      ++this.params.index;
      // this.getRankList();
    },
    // 切换战区
    switchGeneral(id,index){
      if(this.selectGeneralId==id) return;
      this.generalIndex = index;
      this.selectGeneralId = Number(id) || null;
      // 清楚军团选择
      this.selectLegionId = null
      this.legionIndex = null
      this.params.finished = false;
      this.params.index = 1;
      this.list = [];
      var waterMark = document.getElementById('water-mark');
      var childs = waterMark.childNodes;
      var arr = [];
      for (var i = childs.length - 1; i >= 0; i--) {
        arr[i] = childs[i].innerHTML;
        waterMark.removeChild(childs[i]);
      }
      this.getLegionList()
      this.getRankList();
    },
    // 切换军团
    switchLegion(id,index){
      if(this.selectLegionId==id) return;
      this.legionIndex=index;
      this.selectLegionId = Number(id);
      this.params.finished = false;
      this.params.index = 1;
      this.list = [];
      var waterMark = document.getElementById('water-mark');
      var childs = waterMark.childNodes;
      var arr = [];
      for (var i = childs.length - 1; i >= 0; i--) {
        arr[i] = childs[i].innerHTML;
        waterMark.removeChild(childs[i]);
      }
      this.getRankList();
    },
    // 选中日期
    onConfirm(value) {
      console.log(value);
      this.show = !this.show;
      var date = new Date(value);
      console.log(date);
      var time = date.getFullYear() + '-' + formatNumber(date.getMonth() + 1) + '-' + formatNumber(date.getDate());
      console.log(time);
      if (this.flag === 1) {
        this.startTime = time;
      } else if (this.flag === 2) {
        this.endTime = time;
      }
      if(this.startTime&&this.endTime&&(new Date(this.startTime).getTime()>new Date(this.endTime).getTime())){
        this.$toast("开始时间不能大于结束时间");
        this.startTime=this.endTime;
        return;
      }
      this.params.finished = false;
      this.params.start_at = this.startTime+' 00:00:00';
      this.params.end_at = this.endTime+' 23:59:59';
      this.list = [];
      this.params.index = 1;
      this.getRankList();
    },
    // pupop弹框日期格式
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      } else if (type === 'day') {
        return `${value}日`;
      }
      return value;
    },
  }
};

</script>

<style lang="less" scoped>
.kpi-rank-brand-page {
  height: 100vh;
  .legion{
    position: relative;
    z-index: 9;
    margin: 5px;
    display: flex;
    align-items: center;
    div{
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      &::-webkit-scrollbar{
        display: none;
      }
      span{
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 10px 10px;
        background: #fff;
        margin: 0 8px;
        border-radius: 60px;
        &.active{
          background: #5293fd;
          color: #fff;
        }
      }
    }
  }
  .self {
    margin-top: 10px;
  }
  .kpi-rank-brand-list {
    .bottom-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
      font-size: 14px;
      background: #fff;
      span {
        color: #5293fd;
      }
    }
  }
  .group {
    .value {
      color: #323232;
    }
    .van-cell {
      height: 80px;
    }
    .title {
      position: relative;
      z-index: 9;
      display: flex;
      align-items: center;
      min-width: 74%;
      max-width: 74%;
      .no-num {
        border: 2px solid #aedaff;
        box-sizing: border-box;
        background-color: #1986ff;
        color: #ffffff;
        text-align: center;
        width: 28px;
        max-width: 28px;
        min-width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-right: 3px;
      }
      .img_box {
        width: 58px; 
        height: 33px;
        border-radius: 4px;
        margin: 0 5px;
        overflow: hidden;
        img{
          height: 100%;
        }
      }
      .word {
        position: relative;
        width: 66%;
        display: flex;
        flex-direction: column;
        .one-nowrap {
          height: 18px;
          line-height: 18px;
        }
        .store-name {
          font-size: 12px;
        }
        .progress {/*进度条*/
          position: relative;
          left: -4px;
          top: 2px;
          background-color: #eeeeee;
          width: 100%;
          height: 6px;
          margin: 0px 10px 0px 5px;
          border-radius: 4px;
          box-sizing: border-box;
          span {
            // width: 100%;
            position: absolute;
            left: 0px;
            background-color: #3283fa;
            height: 6px;
            border-radius: 4px;
          }
        }
      }
    }

    /deep/.van-cell {
      align-items: center;
    }
    /deep/.van-cell:not(:last-child)::after {
      left: 0;
    }

    .icon {display: block;position: relative;width: 30px;height: 30px;margin: 0 auto;}
    .icon-no1 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -5px -3px;background-size: 140px 38px;}
    .icon-no2 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -53px -3px;background-size: 140px 38px;}
    .icon-no3 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -106px -3px;background-size: 140px 38px;}
  }

  .cell-group {/*每日排行输入框样式*/
    .bottom-line::after {
      left: 15px;
    }
    /deep/.van-field__label {
      width: 150px;
      max-width: 200px;
    }
    /deep/.van-field__control {
      //text-align: right;
      color: #999999;
    }
  }
}
</style>
